import { ApiRequest } from '../../api/request';

export class PADContactService extends ApiRequest {
  constructor($http, $q, appConfig, User) {
    'ngInject';
    super({ $http, $q, appConfig, User });
  }

  findByBLZOrIban(term) {
    return this.$http({
      method: 'GET',
      url: `${this.api}/aid/padcontact/${term}`,
      error: { silent: true },
    });
  }
}
